import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { RestApiService } from '../common-app/service/rest-api.service';
import { Kvaw0400Vo } from './kvaw0400.vo';
import { DateUtil } from '../common-app/util/date-util';

/**
 * サーバとの通信を行う。
 * @see WebAPI仕様_KVAW0400（担当店一覧取得）.xlsx
 */
@Injectable()
export class Kvaw0400Service {

  /** 検索対象 */
  private static TARGET = 'kvaw0400';

  constructor(
    private restApiService: RestApiService,
  ) { }

  /**
   * 担当店一覧を検索する
   *
   * @param startDate 検索対象週（YYYYMMDD形式の文字列）の開始日
   * @param endDate 検索対象週（YYYYMMDD形式の文字列）の終了日
   */
  searchStores(startDate?: string, endDate?: string): Observable<Kvaw0400Vo> {
    const param = {};
    if (startDate && endDate) {
      param['startDate'] = startDate;
      param['endDate'] = endDate;
    }
    return this.restApiService.search<Kvaw0400Vo>(Kvaw0400Service.TARGET, param);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/kvaw0400.service.ts